import { jsonOrThrow } from "./api.js";
export async function recordRecommendationExposure(client, body) {
    const response = await client.api.library.recommendations.exposures.$post({ json: body });
    await jsonOrThrow(response, "POST /api/library/recommendations/exposures");
}
/** One impression per mounted card. Failed writes can be retried on the next visibility check. */
export function createRecommendationExposureReporter(args) {
    let shown = false;
    let tracked = false;
    let pending = false;
    return async (interaction) => {
        if (interaction === "shown" && (shown || pending))
            return;
        if (interaction === "shown") {
            pending = true;
            if (!tracked) {
                tracked = true;
                args.onShown();
            }
        }
        try {
            await args.send(interaction);
            if (interaction === "shown")
                shown = true;
            args.onRecorded();
        }
        catch {
            // Reporting must never prevent a member opening the content.
        }
        finally {
            if (interaction === "shown")
                pending = false;
        }
    };
}
export function recommendationIsVisible(rect, viewport) {
    if (rect.width <= 0 || rect.height <= 0)
        return false;
    const width = Math.max(0, Math.min(rect.x + rect.width, viewport.width) - Math.max(rect.x, 0));
    const height = Math.max(0, Math.min(rect.y + rect.height, viewport.height) - Math.max(rect.y, 0));
    return width * height >= rect.width * rect.height * 0.5;
}
//# sourceMappingURL=recommendation-exposure.js.map